module.exports = __webpack_public_path__ + "img/battle_section4_title.6cfcf853.png";